import * as React from "react";
import i18next from "i18next";
import { WidgetToolbarButton } from "../Widget/WidgetToolbarButton";
import { useCallback, useEffect, useRef } from "react";
import { useMapDownloadContext } from "../../Contexts/MapDownloadContext";
import { Draw } from "ol/interaction";
import { Vector as VectorSource } from "ol/source";
import { getMap } from "../GeoLiteMap";
import { Feature } from "ol";
import { SheetSelectMode } from "../enums";

export const PolygonSelect = (): JSX.Element => {
    const { sheetSelectMode, setSheetSelectMode, setSheetSelectPolygon } = useMapDownloadContext();

    const drawRef = useRef<Draw>();
    const sourceRef = useRef<VectorSource>(new VectorSource());
    const polygonRef = useRef<Feature>();
    const clickListenerRef = useRef<() => void>();

    useEffect(() => {
        sheetSelectMode && sheetSelectMode === SheetSelectMode.Polygon
            ? !drawRef.current && addInteraction()
            : drawRef.current && removeInteraction();
    }, [sheetSelectMode]);

    const addInteraction = () => {
        drawRef.current = new Draw({
            source: sourceRef.current,
            type: "Polygon"
        });

        drawRef.current.on("drawstart", (e) => {
            polygonRef.current = e.feature;
        });

        clickListenerRef.current = clickListener;
        getMap().on("click", clickListenerRef.current);

        getMap().addInteraction(drawRef.current);
    };

    const removeInteraction = () => {
        getMap().un("click", clickListenerRef.current);
        clickListenerRef.current = null;
        getMap().removeInteraction(drawRef.current);
        drawRef.current = null;
        polygonRef.current = null;
    };

    const clickListener = () => polygonRef.current && setSheetSelectPolygon(polygonRef.current);

    const onClickSelect = useCallback(() => {
        setSheetSelectMode(
            sheetSelectMode && sheetSelectMode === SheetSelectMode.Polygon ? null : SheetSelectMode.Polygon
        );
    }, [sheetSelectMode]);

    return (
        <WidgetToolbarButton
            iconClass="icon-geolite-area"
            buttonClass={sheetSelectMode && sheetSelectMode === SheetSelectMode.Polygon ? "active" : ""}
            title={i18next.t("mapDownload.drawPolygon")}
            onClick={onClickSelect}
        />
    );
};
